export default __webpack_public_path__ + "static/pragicts-ai-healthcare-76d937b2e369c25ee7abc9a07022ffde.jpg";